import { forwardRef, HTMLProps } from 'react'
import { FloatingPortal, useMergeRefs } from '@floating-ui/react'
import { usePopoverContext } from './popover'

export const PopoverContent = forwardRef<HTMLDivElement, HTMLProps<HTMLDivElement>>(({ style, ...props }, propRef) => {
  const { context: floatingContext, ...context } = usePopoverContext()
  const ref = useMergeRefs([context.refs.setFloating, propRef])

  if (!floatingContext.open) return null

  return (
    <FloatingPortal>
      <div
        ref={ref}
        style={{ ...context.floatingStyles, ...style }}
        aria-labelledby={context.labelId}
        aria-describedby={context.descriptionId}
        {...context.getFloatingProps(props)}
      >
        {props.children}
      </div>
    </FloatingPortal>
  )
})

PopoverContent.displayName = 'PopoverContent'
